import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import station from "./station";

angular
    .module('stationsControl.component', [
        angularUIB,
        core,
        station
    ])
    .component('stationsControl', {
        controller: ['$uibModal', 'notifier', 'Station', controller],
        template: require('./stations-control.component.html'),
        bindings: {
        }
    });

function controller($uibModal, notifier, Station) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.onlyKZ = true;
        $ctrl.onlyEdited = false;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.search = null;
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Station
            .getList({
                currentPage: $ctrl.currentPage,
                search: $ctrl.search,
                onlyKZ: +$ctrl.onlyKZ,
                onlyEdited: +$ctrl.onlyEdited,
            })
            .then(
                function (response) {
                    $ctrl.stations = response.data.stations;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default 'stationsControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/stations-control/stations-control.component.js